import { useState } from "react";

export const ButtonWithText = ({ onClick, children }) => {
    const [isDisabled, setIsDisabled] = useState(false);
    //let buttonRef = useRef(null);

    return (
        <button
            className={isDisabled ? "btn btn-primary disabled" : "btn btn-primary"}
            //ref={buttonRef}
            disabled={isDisabled}
            onClick={(e) => {
                if (isDisabled) return;
                console.log("set disabled waiting for callback");

                setIsDisabled(true);
                onClick()
                    .then((p) => {
                        // setTimeout(() => {
                        console.log("callback received, success");
                        setIsDisabled(false);
                    })
                    .catch((err) => {
                        console.log("callback received, error");
                        setIsDisabled(false);
                    });
            }}
        >
            {children}
        </button>
    );
};
